var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgManabakhLogo = function SvgManabakhLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 264,
    height: 55,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#manabakhLogo_svg__a)",
    d: "m251.056 55 12.022-12.003V24.709C263.078 11.603 252.458 1 239.331 1H207.23l-12.023 12.003h55.849z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#manabakhLogo_svg__b)",
    d: "M251.057 13.003c0-6.642-5.37-12.003-12.023-12.003h-19.362v12.003z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#manabakhLogo_svg__c)",
    d: "m190.941 1-12.023 12.003v18.288c0 13.106 10.621 23.709 23.748 23.709h32.1l12.023-12.003h-55.848z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#manabakhLogo_svg__d)",
    d: "M190.941 42.997c0 6.642 5.37 12.003 12.023 12.003h12.68V42.997z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "m226.082 26.407-8.145-4.706c-1.253-.715-2.804.178-2.804 1.608v9.382c0 1.43 1.551 2.324 2.804 1.609l8.145-4.647c1.253-.714 1.253-2.531 0-3.246M144.61 42.764v-8.137h6.079c4.467 0 8.084-3.64 8.084-8.137s-3.617-8.136-8.084-8.136h-8.084v16.273l-8.085 8.137h-14.162v-8.137h14.162v-24.44h16.199c8.935 0 16.199 7.31 16.199 16.304s-7.264 16.304-16.199 16.304zM118.291 14.255l-8.084 8.137v12.235h-6.078v-24.44h-16.2c-8.934 0-16.198 7.31-16.198 16.304v16.304h14.132l8.145-8.137H79.846V26.46c0-4.497 3.616-8.137 8.084-8.137h8.084v24.441h14.162l8.115-8.137zM2.924 12.205l8.084 8.137h14.163v6.118h-8.054C8.182 26.46.918 33.77.918 42.764v4.069h8.084v-4.069c0-4.497 3.617-8.137 8.084-8.137h16.2V20.342L25.2 12.205zM67.689 34.627l-8.084 8.137H37.358V10.186l8.084-8.167v32.608zM114.249 10.186c2.249 0 4.042-1.835 4.042-4.068 0-2.264-1.823-4.068-4.042-4.068-2.249 0-4.042 1.835-4.042 4.068s1.823 4.068 4.042 4.068M55.562 55c2.25 0 4.043-1.835 4.043-4.068 0-2.264-1.824-4.069-4.043-4.069-2.249 0-4.042 1.836-4.042 4.069S53.313 55 55.562 55M9.002 8.137c2.25 0 4.042-1.836 4.042-4.069C13.044 1.805 11.221 0 9.002 0 6.753 0 4.96 1.835 4.96 4.068s1.824 4.069 4.042 4.069"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "manabakhLogo_svg__a",
    x1: 222.909,
    x2: 244.94,
    y1: 38.782,
    y2: 0.561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6D63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.497,
    stopColor: "#B21F1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#711010"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "manabakhLogo_svg__b",
    x1: 219.67,
    x2: 251.059,
    y1: 7.001,
    y2: 7.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "red",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#C60000",
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.397,
    stopColor: "maroon",
    stopOpacity: 0.397
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.602,
    stopColor: "#490000",
    stopOpacity: 0.602
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.776,
    stopColor: "#210000",
    stopOpacity: 0.776
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.915,
    stopColor: "#090000",
    stopOpacity: 0.915
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "manabakhLogo_svg__c",
    x1: 197.014,
    x2: 219.046,
    y1: 55.415,
    y2: 17.194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#711010"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.464,
    stopColor: "#B21F1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.855,
    stopColor: "#FF6D63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.893,
    stopColor: "#FF7E76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.961,
    stopColor: "#FF9893"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA29E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "manabakhLogo_svg__d",
    x1: 190.952,
    x2: 215.662,
    y1: 49.006,
    y2: 49.006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.085,
    stopColor: "#090000",
    stopOpacity: 0.915
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.224,
    stopColor: "#210000",
    stopOpacity: 0.776
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.399,
    stopColor: "#490000",
    stopOpacity: 0.602
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.603,
    stopColor: "maroon",
    stopOpacity: 0.397
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#C60000",
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "red",
    stopOpacity: 0
  })))));
};
export default SvgManabakhLogo;